import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ref, get, update } from 'firebase/database';
import { database } from '../firebaseConfig';

function QRRedirect() {
  const { id } = useParams();

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        const qrRef = ref(database, `QRs/${id}`);
        const snapshot = await get(qrRef);
        if (!snapshot.exists()) {
          window.location.replace('/'); // fallback si no existe
          return;
        }
        const qr = snapshot.val();
        const url = qr.url;
        // Incrementar visitas por fecha
        const hoy = new Date().toISOString().split('T')[0];
        const visitas = qr.visitas || {};
        visitas[hoy] = (visitas[hoy] || 0) + 1;
        await update(qrRef, { visitas });
        // Redirigir
        window.location.replace(url);
      } catch (e) {
        window.location.replace('/'); // fallback si error
      }
    };
    fetchAndRedirect();
    // eslint-disable-next-line
  }, [id]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', fontSize: 20, color: '#1a3b5d' }}>
      Cargando dirección URL...
    </div>
  );
}

export default QRRedirect; 
